/*
  Video Modal
 */

var VideoModal = (function ($) {
  var m = (function () {
    var name = 'Video Modal';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      playVideo: function ($trigger) {
        var $videoModal = $('.js-video-modal');
        var $video = $videoModal.find('iframe');
        var videoId = $trigger.data('video-id');
        var src = 'https://www.youtube.com/embed/' + videoId;

        $video.attr('src', src + '?rel=0&autoplay=1');

        $videoModal.modal('show');
      },
      stopVideo: function () {
        var $videoModal = $('.js-video-modal');
        var $video = $videoModal.find('iframe');

        $video.attr('src', '');
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
    ];

    /*
      Events
    */
    var events = {
      onTriggerClick: function () {
        $('.js-video-modal-trigger').off().on('click', function (event) {
          event.preventDefault();

          handlers.playVideo($(this));
        });
      },
      onModalClose: function () {
        $('.js-video-modal').on('hide.bs.modal', function () {
          handlers.stopVideo();
        });
      },
      pageLoad: function () {
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  $(function () {
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
